import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FileText, Plus, Settings, Search } from 'lucide-react';

const Pages = () => {
  const { currentUser } = useAuth();

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-slate-100">Pages</h1>
          <p className="text-slate-400 mt-1">Manage and create custom pages for your business unit</p>
        </div>
        <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2">
          <Plus className="w-4 h-4" />
          New Page
        </button>
      </div>

      {/* Coming Soon Content */}
      <div className="bg-slate-800 rounded-lg border border-slate-700 p-8 text-center">
        <div className="max-w-md mx-auto">
          <FileText className="w-16 h-16 text-slate-600 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-slate-200 mb-4">Pages Feature Coming Soon</h2>
          <p className="text-slate-400 mb-6">
            This section will allow you to create and manage custom pages for your business unit. 
            Features will include:
          </p>
          
          <div className="text-left space-y-3 mb-6">
            <div className="flex items-center gap-3 text-slate-300">
              <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
              <span>Custom content pages</span>
            </div>
            <div className="flex items-center gap-3 text-slate-300">
              <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
              <span>Rich text editor</span>
            </div>
            <div className="flex items-center gap-3 text-slate-300">
              <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
              <span>Document templates</span>
            </div>
            <div className="flex items-center gap-3 text-slate-300">
              <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
              <span>File attachments</span>
            </div>
            <div className="flex items-center gap-3 text-slate-300">
              <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
              <span>Version control</span>
            </div>
            <div className="flex items-center gap-3 text-slate-300">
              <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
              <span>Access permissions</span>
            </div>
          </div>

          <div className="bg-slate-700/50 rounded-lg p-4 border border-slate-600">
            <p className="text-slate-300 text-sm">
              <strong>Business Unit:</strong> {currentUser?.businessUnit?.name || 'Not specified'}
            </p>
            <p className="text-slate-400 text-xs mt-1">
              Pages created here will be specific to your business unit
            </p>
          </div>
        </div>
      </div>

      {/* Mock Preview of Future Features */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-slate-800 rounded-lg border border-slate-700 p-6 opacity-50">
          <div className="flex items-center gap-3 mb-4">
            <Search className="w-5 h-5 text-slate-400" />
            <h3 className="text-lg font-semibold text-slate-300">Search & Filter</h3>
          </div>
          <p className="text-slate-400 text-sm">
            Quickly find pages with advanced search and filtering options
          </p>
        </div>

        <div className="bg-slate-800 rounded-lg border border-slate-700 p-6 opacity-50">
          <div className="flex items-center gap-3 mb-4">
            <FileText className="w-5 h-5 text-slate-400" />
            <h3 className="text-lg font-semibold text-slate-300">Templates</h3>
          </div>
          <p className="text-slate-400 text-sm">
            Pre-built page templates for common business documents
          </p>
        </div>

        <div className="bg-slate-800 rounded-lg border border-slate-700 p-6 opacity-50">
          <div className="flex items-center gap-3 mb-4">
            <Settings className="w-5 h-5 text-slate-400" />
            <h3 className="text-lg font-semibold text-slate-300">Settings</h3>
          </div>
          <p className="text-slate-400 text-sm">
            Configure page permissions and sharing settings
          </p>
        </div>
      </div>
    </div>
  );
};

export default Pages;